"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _caret_icon = _interopRequireDefault(require("./assets/caret_icon.svg"));
var _FlexBox = _interopRequireDefault(require("schoolUiComponents/basic/Box/FlexBox"));
var _colors = require("baseStyles/enums/colors");
require("./styles.scss");
var _styles2 = _interopRequireDefault(require("./styles"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectDestructuringEmpty(obj) { if (obj == null) throw new TypeError("Cannot destructure " + obj); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i["return"] && (_r = _i["return"](), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
var ScrollerContext = /*#__PURE__*/_react["default"].createContext({});
var Scroller = function Scroller(_ref) {
  var onScrollChange = _ref.onScrollChange,
    children = _ref.children;
  var scrollableViewRef = (0, _react.useRef)();
  var _useState = (0, _react.useState)(false),
    _useState2 = _slicedToArray(_useState, 2),
    hasNext = _useState2[0],
    setHasNext = _useState2[1];
  var _useState3 = (0, _react.useState)(false),
    _useState4 = _slicedToArray(_useState3, 2),
    hasPrev = _useState4[0],
    setHasPrev = _useState4[1];
  var scrollTimeoutRef = (0, _react.useRef)(null);
  var scrollLeftValue = (0, _react.useRef)(0);
  var scroll = function scroll(val) {
    try {
      if (hasNext || hasPrev) {
        var _scrollableViewRef$cu, _scrollableViewRef$cu2;
        var width = ((_scrollableViewRef$cu = scrollableViewRef.current) === null || _scrollableViewRef$cu === void 0 ? void 0 : _scrollableViewRef$cu.clientWidth) - 50;
        (_scrollableViewRef$cu2 = scrollableViewRef.current) === null || _scrollableViewRef$cu2 === void 0 ? void 0 : _scrollableViewRef$cu2.scrollBy({
          left: width * val,
          behavior: 'smooth'
        });
      }
    } catch (e) {
      console.error(e);
    }
  };
  var checkScrollState = function checkScrollState(event) {
    if (scrollTimeoutRef.current) {
      clearTimeout(scrollTimeoutRef.current);
      scrollTimeoutRef.current = null;
    }
    scrollTimeoutRef.current = setTimeout(function () {
      try {
        var _scrollableViewRef$cu3, _scrollableViewRef$cu4, _scrollableViewRef$cu5;
        var scrollLeft = (_scrollableViewRef$cu3 = scrollableViewRef.current) === null || _scrollableViewRef$cu3 === void 0 ? void 0 : _scrollableViewRef$cu3.scrollLeft;
        var scrollWidth = (_scrollableViewRef$cu4 = scrollableViewRef.current) === null || _scrollableViewRef$cu4 === void 0 ? void 0 : _scrollableViewRef$cu4.scrollWidth;
        var width = (_scrollableViewRef$cu5 = scrollableViewRef.current) === null || _scrollableViewRef$cu5 === void 0 ? void 0 : _scrollableViewRef$cu5.clientWidth;
        setHasPrev(scrollLeft > 0);
        setHasNext(Math.ceil(scrollLeft + width) < scrollWidth);
        if (event !== null && event !== void 0 && event.target) {
          var _event$target;
          onScrollChange((event === null || event === void 0 ? void 0 : (_event$target = event.target) === null || _event$target === void 0 ? void 0 : _event$target.scrollLeft) > scrollLeftValue.current ? 'Right scroll' : 'Left scroll');
        }
        scrollLeftValue.current = scrollLeft;
      } catch (e) {
        console.log(e);
      }
      clearTimeout(scrollTimeoutRef.current);
      scrollTimeoutRef.current = null;
    }, 100);
  };
  var handleClick = function handleClick(event) {
    try {
      var _event$target2, _event$target2$scroll;
      (_event$target2 = event.target) === null || _event$target2 === void 0 ? void 0 : (_event$target2$scroll = _event$target2.scrollIntoView) === null || _event$target2$scroll === void 0 ? void 0 : _event$target2$scroll.call(_event$target2, {
        behavior: 'smooth',
        block: 'nearest',
        inline: 'center'
      });
      checkScrollState();
    } catch (e) {}
  };
  var scrollerContextValue = {
    scrollableViewRef: scrollableViewRef,
    scroll: scroll,
    handleClick: handleClick,
    hasNext: hasNext,
    hasPrev: hasPrev
  };
  (0, _react.useEffect)(function () {
    var _scrollableViewRef$cu6;
    checkScrollState();
    (_scrollableViewRef$cu6 = scrollableViewRef.current) === null || _scrollableViewRef$cu6 === void 0 ? void 0 : _scrollableViewRef$cu6.addEventListener('scroll', checkScrollState);
    return function () {
      var _scrollableViewRef$cu7;
      (_scrollableViewRef$cu7 = scrollableViewRef.current) === null || _scrollableViewRef$cu7 === void 0 ? void 0 : _scrollableViewRef$cu7.removeEventListener('scroll', checkScrollState);
    };
  }, [scrollableViewRef.current]);
  return /*#__PURE__*/_react["default"].createElement(ScrollerContext.Provider, {
    value: scrollerContextValue,
    "data-sentry-element": "unknown",
    "data-sentry-component": "Scroller",
    "data-sentry-source-file": "index.tsx"
  }, children);
};
Scroller.Box = function (_ref2) {
  var children = _ref2.children;
  var _useContext = (0, _react.useContext)(ScrollerContext),
    scrollableViewRef = _useContext.scrollableViewRef,
    handleClick = _useContext.handleClick;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "sui-scroller",
    ref: scrollableViewRef
  }, /*#__PURE__*/_react["default"].createElement(_FlexBox["default"], {
    noWrap: true
  }, children));
};
Scroller.Next = function (_ref3) {
  _objectDestructuringEmpty(_ref3);
  var _useContext2 = (0, _react.useContext)(ScrollerContext),
    scroll = _useContext2.scroll,
    hasNext = _useContext2.hasNext;
  var styles = (0, _styles2["default"])();
  return /*#__PURE__*/_react["default"].createElement(_FlexBox["default"], _extends({
    timeout: 500
  }, styles.scrollButton, {
    backgroundColor: hasNext ? _colors.Colors.MEDIUM_PURPLE : _colors.Colors.LIGHT_GREY_1,
    hover: hasNext ? {
      backgroundColor: _colors.Colors.NAVY_BLUE_1
    } : {},
    transform: "rotate(-90deg)",
    onClick: hasNext ? function () {
      scroll(1);
    } : null
  }), /*#__PURE__*/_react["default"].createElement(_caret_icon["default"], {
    fill: _colors.Colors.WHITE
  }));
};
Scroller.Prev = function (_ref4) {
  _objectDestructuringEmpty(_ref4);
  var _useContext3 = (0, _react.useContext)(ScrollerContext),
    scroll = _useContext3.scroll,
    hasPrev = _useContext3.hasPrev;
  var styles = (0, _styles2["default"])();
  return /*#__PURE__*/_react["default"].createElement(_FlexBox["default"], _extends({
    timeout: 500
  }, styles.scrollButton, {
    backgroundColor: hasPrev ? _colors.Colors.MEDIUM_PURPLE : _colors.Colors.LIGHT_GREY_1,
    hover: hasPrev ? {
      backgroundColor: _colors.Colors.NAVY_BLUE_1
    } : {},
    transform: "rotate(90deg)",
    onClick: hasPrev ? function () {
      scroll(-1);
    } : null
  }), /*#__PURE__*/_react["default"].createElement(_caret_icon["default"], {
    fill: _colors.Colors.WHITE
  }));
};
var _default = Scroller;
exports["default"] = _default;